import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const notificationApi = createApi({
    reducerPath: "notification",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['notification'],
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: ({page, limit}) => ({
                url: `getnotifications?pageno=${page}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ['notification'],
        }),
          markAsRead: builder.mutation({
            query: (data) => ({
                url: `notifications/mark-read`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['notification'],
        }),
    })
});

export const { useGetNotificationsQuery, useMarkAsReadMutation } = notificationApi;